import { render } from "./ai-grid-virtual-base.vue?vue&type=template&id=74152e2a&scoped=true"
import script from "./ai-grid-virtual-base.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-grid-virtual-base.vue?vue&type=script&setup=true&lang=js"

import "./ai-grid-virtual-base.vue?vue&type=style&index=0&id=74152e2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74152e2a"],['__file',"src/components/ai-grid-virtual/ai-grid-virtual-base.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74152e2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74152e2a', __exports__)) {
    api.reload('74152e2a', __exports__)
  }
  
  module.hot.accept("./ai-grid-virtual-base.vue?vue&type=template&id=74152e2a&scoped=true", () => {
    api.rerender('74152e2a', render)
  })

}


export default __exports__